import classNames from 'classnames';
import React from 'react';

import { RowButton } from '@eika/button';
import { Icon, IconTypes } from '@eika/icon';

import './SelectPanel.scss';

type SelectPanelTypes = {
    isSelected: boolean;
    icon: IconTypes;
    label: string;
    onClick?: () => void;
    disabled?: boolean;
    trackId: string;
};

const SelectPanel = ({ isSelected, label, icon, onClick, disabled, trackId }: SelectPanelTypes) => {
    return (
        <RowButton
            disabled={disabled}
            onClick={onClick}
            className={classNames('select-panel', { selected: isSelected })}
            data-track-id={trackId}
            data-track-linkname={label}
        >
            {icon && <Icon className="icon--36" type={icon} />}
            <span className="label">{label}</span>
            {isSelected && <Icon type={IconTypes.CHECKED_24} />}
        </RowButton>
    );
};

export default SelectPanel;
